import React from "react";
import { Link, StaticQuery } from "gatsby";
import styled from "styled-components";
import Img from "gatsby-image";
import { useMediaQuery } from 'react-responsive';
import { InlineWidget, PopupWidget } from "react-calendly";
import CallButtonV2 from "./CallButtonV2";


const CalendlyPanelInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 100px);
  margin: 70px auto;
  max-width: 1150px;

  @media (max-width: 899px) {
    width: calc(100% - 50px);
    max-width: 700px;
  }

  @media (max-width: 750px) {
    display: block;
  }

  @media (max-width: 600px) {
    margin: 50px auto;
  }

  .left {
    max-width: 600px;
    width: calc(100% - 320px - 50px);

    @media (max-width: 750px) {
      width: 100%;
      margin-bottom: 40px;
    }
  }

  h2 {
    text-align: left;
    font-family: NewKansas;
    font-size: 36px;
    color: #2c4668;
    line-height: 50px;

    @media (max-width: 899px) {
      font-size: 32px;
      line-height: 40px;
    }

    @media (max-width: 430px) {
      font-size: 28px;
      line-height: 35px;
    }
  }

  p {
    font-family: Visuelt-Regular;
    font-size: 18px;
    color: #394B5C;
    text-align: left;
    line-height: 28px;
    max-width: 900px;
    margin: 30px auto;

    @media (max-width: 1250px) {
      max-width: 700px;
    }

    @media (max-width: 430px) {
      font-size: 16px;
      line-height: 24px;
      margin-top: 25px;
    }
  }

  .calendly-inline-widget {
    height: 500px !important;
    width: 320px;

    @media (max-width: 750px) {
      width: 100%;
      min-width: 0 !important;
    }
  }

  .obrazek {
    margin-bottom: 30px;

    @media (max-width: 430px) {
      width: 200px !important;
      height: 100px !important;
    }
  }
`;



const CalendlyPanel = () => {
  const isLess1000 = useMediaQuery({
    query: '(max-width: 1000px)'
  });

  const isLess899 = useMediaQuery({
    query: '(max-width: 899px)'
  });

  return (
    <CalendlyPanelInner>
        <div className="left">
          <h2>Pojďme si o tom popovídat</h2>
          <p>Naplánujte si nezávaznou 30 minutovou konzultaci s naším specialistou. Odpovíme vám na všechny vaše dotazy a pomůžeme vám zjisit jestli je předplacený pohřeb pro vás ta správná volba.</p>
          <StaticQuery
            query={graphql`
              query {
                file(relativePath: { eq: "podpora.png" }) {
                  childImageSharp {
                    fixed(width: 300, quality: 100) {
                      ...GatsbyImageSharpFixed_noBase64
                    }
                  }
                }
              }
            `}
            render={data => (
              <Img className="obrazek" alt="Naše podpora" fixed={data.file.childImageSharp.fixed} />
            )}
          />
          <CallButtonV2 />
        </div>
        <InlineWidget url="https://calendly.com/janostikova/predplaceny-pohreb?hide_event_type_details=1&hide_gdpr_banner=1" />
    </CalendlyPanelInner>
  );
}

export default CalendlyPanel;


